export default "__VITE_ASSET__OpNpPyBn__"